"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GlRenderer = void 0;
const rc_js_util_1 = require("rc-js-util");
const gl_component_renderer_provider_1 = require("./component-renderer/gl-component-renderer-provider");
const gl_component_renderer_factory_1 = require("./gl-component-renderer-factory");
const developer_error_localization_1 = require("../../errors/developer-error-localization");
const gl_renderer_shared_state_1 = require("./gl-renderer-shared-state");
const transform_component_store_1 = require("../transform-components/transform-component-store");
const graphics_component_store_1 = require("../graphics-component-store");
const emit_context_loss_on_entity_gl_buffers_1 = require("./buffers/emit-context-loss-on-entity-gl-buffers");
const reinitialize_buffer_layouts_1 = require("./buffers/reinitialize-buffer-layouts");
/**
 * @public
 * {@inheritDoc IGlRenderer}
 */
class GlRenderer {
    constructor(context, options, renderContextFactory, callbacks, sharedState) {
        this.graphicsComponents = new graphics_component_store_1.GraphicsComponentStore();
        this.callbacks = {
            onBeforePlotDraw: (context, plotDimensions) => {
                this.sharedState.updateScissorRange(plotDimensions.pixelArea.wholeRange);
                context.clearColor(this.clearColor[0], this.clearColor[1], this.clearColor[2], this.clearColor[3]);
                context.clear(this.clearBit);
            },
            onAfterPlotDraw() {
                // no action needed
            },
        };
        if (callbacks != null) {
            rc_js_util_1._Dictionary.extend(this.callbacks, callbacks);
        }
        this.sharedState = sharedState;
        this.context = context;
        this.componentRendererProvider = new gl_component_renderer_provider_1.GlComponentRendererProvider();
        this.componentRendererFactory = renderContextFactory;
        this.transformComponents = new transform_component_store_1.TransformComponentStore();
        rc_js_util_1._Array.forEach(options.onCreate.featuresToEnable, feature => this.context.enable(this.context[feature]));
        this.clearBit = options.onNewFrame.bufferBitsToClear.reduce((clearBit, flagName) => clearBit | this.context[flagName], 0);
        this.clearColor = options.onNewFrame.clearWithColor;
    }
    static createOne(context, options, localizations = developer_error_localization_1.developerErrorLocalization, callbacks) {
        if (context == null) {
            return null;
        }
        const extensions = gl_component_renderer_factory_1.GlComponentRendererFactory.getExtensions(context, options.onCreate.requiredExtensionsToGet);
        const sharedState = gl_renderer_shared_state_1.GlRendererSharedState.createOne(context, extensions, context instanceof WebGL2RenderingContext);
        const factory = gl_component_renderer_factory_1.GlComponentRendererFactory.createOne(context, extensions, sharedState, localizations);
        if (factory == null || sharedState == null) {
            return null;
        }
        return new GlRenderer(context, options, factory, callbacks, sharedState);
    }
    onBeforePlotDraw(plot, canvasDims) {
        this.sharedState.onNewFrame();
        this.callbacks.onBeforePlotDraw(this.context, plot.plotDimensionsOBL, canvasDims);
    }
    onAfterPlotDraw() {
        this.callbacks.onAfterPlotDraw(this.context);
    }
    onContextLost() {
        this.componentRendererProvider.onContextLost();
        this.sharedState.onContextLost();
        (0, emit_context_loss_on_entity_gl_buffers_1.emitContextLossOnEntityGlBuffers)(this.sharedState.entityBuffers);
    }
    onContextRegained(context) {
        this.context = context;
        this.sharedState.setContext(context);
        this.componentRendererFactory.setContext(context);
        this.componentRendererProvider.reinitializeRenderers(this.componentRendererFactory);
        this.graphicsComponents.reinitializeGraphicsComponents(this);
        (0, reinitialize_buffer_layouts_1.reinitializeBufferLayouts)(this.context, this.sharedState.entityBuffers);
    }
    initializeBuffers(buffers) {
        for (let i = 0, iEnd = buffers.length; i < iEnd; ++i) {
            buffers[i].initialize(this.context);
        }
    }
    destroyBuffers(buffers) {
        for (let i = 0, iEnd = buffers.length; i < iEnd; ++i) {
            buffers[i].destroy(this.context);
        }
    }
}
exports.GlRenderer = GlRenderer;
//# sourceMappingURL=gl-renderer.js.map